export default __webpack_public_path__ + "static/media/8.34654405.jpg";